/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/self-closing-comp */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import {
  formatDate,
  formatTimeString,
  getCabinBaggage,
  getTerminalNumberwithTerminal,
  convertTravelTime,
  getConnectingTime,
  getNewDate,
} from '../../shared/helper-utils/appUtils';
import {
  DATE_MONTH_YEAR_VIEW_FORMAT,
  ONLY_DATE_MONTH_FORMAT,
} from '../../shared/constants/Constants';
import AppFlightLogo from '../../shared/components/app-flight-logo/AppFlightLogo';
import { useAppContext } from '../../saas/AppConfigWrapper';

function IntlMuliCityEmailCard({
  flight,
  isLast,
  showHideFare,
  fare,
  showInput,
  index,
  markUpToBeAdded,
  searchRequest,
}) {
  const { appConfig } = useAppContext();
  const getAmount = (val) => {
    const markup = markUpToBeAdded === '' ? 0 : parseInt(markUpToBeAdded, 10);
    return parseInt(val, 10) + markup;
  };

  const getOnwardDate = (selectedIndex) => {
    const newDatesArray = [];
    const datesArray = searchRequest.onwarddate.split(':');
    datesArray.forEach((date) => {
      const newdate = `${date.substring(0, 4)}-${date.substring(
        4,
        6,
      )}-${date.substring(6, 8)}`;
      newDatesArray.push(newdate);
    });
    return newDatesArray[selectedIndex];
  };

  return flight.map((onwardFlight, secIndex) => (
    <React.Fragment key={secIndex}>
      <div
        style={{
          backgroundColor: '#fc790e',
          color: '#fff',
          fontSize: '14px',
          fontWeight: '500',
          padding: '5px 10px',
        }}
      >
        {`${
          searchRequest.originlocations.split(':')[secIndex].split(',')[0]
        } - ${
          searchRequest.destinationlocations.split(':')[secIndex].split(',')[0]
        } | ${formatDate(
          getNewDate(getOnwardDate(secIndex)),
          ONLY_DATE_MONTH_FORMAT,
        )}`}
      </div>
      <div
        style={{
          backgroundColor: '#fff',
          padding: '16px',
          borderBottom: isLast ? 'none' : '1px solid #ccc',
          fontSize: '13px',
          color: '#141f3b',
        }}
      >
        <table style={{ width: '100%' }} key={secIndex}>
          <tbody>
            {onwardFlight.flightlegs.map((flightleg, legIndex) => {
              const finalDestination =
                onwardFlight.flightlegs[onwardFlight.flightlegs.length - 1]
                  .destination;
              return (
                <React.Fragment
                  key={`${flightleg.origin}_${flightleg.destination}`}
                >
                  <tr>
                    <td style={{ width: '20%' }}>
                      <table>
                        <tbody>
                          <tr>
                            <td>
                              <AppFlightLogo
                                width="30px"
                                carrier={flightleg.carrier.substring(0, 2)}
                              />
                            </td>
                            <td>
                              <table>
                                <tbody>
                                  <tr>
                                    <td
                                      style={{
                                        fontWeight: '500',
                                      }}
                                    >
                                      {flightleg.validatingcarriername}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ color: '#5b5b5b' }}>
                                      {flightleg.carrier.substring(0, 2)}-
                                      {flightleg.flightnumber}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td style={{ width: '20%' }}>
                      <table>
                        <tbody>
                          <tr>
                            <td style={{ fontWeight: '500' }}>
                              {formatDate(
                                getNewDate(flightleg.depdate),
                                DATE_MONTH_YEAR_VIEW_FORMAT,
                              )}
                              , {formatTimeString(flightleg.deptime)}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ fontSize: '12px' }}>
                              {flightleg.origin_name}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ fontSize: '10px' }}>
                              {getTerminalNumberwithTerminal(
                                flightleg.depterminal,
                              ) !== '' &&
                                `${getTerminalNumberwithTerminal(
                                  flightleg.depterminal,
                                )}`}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td style={{ width: '13%' }}>
                      <table
                        style={{
                          marginLeft: 'auto',
                          marginRight: 'auto',
                          textAlign: 'center',
                        }}
                      >
                        <tbody>
                          <tr>
                            <td style={{ fontSize: '11px', fontWeight: '500' }}>
                              {convertTravelTime(flightleg.journeyduration)}
                            </td>
                          </tr>
                          <tr>
                            <td> </td>
                          </tr>
                          <tr>
                            <td>
                              <div
                                style={{
                                  position: 'relative',
                                  width: '50px',
                                  height: '2px',
                                  backgroundColor: '#ccc',
                                }}
                              >
                                <div
                                  style={{
                                    position: 'absolute',
                                    display: 'none',
                                    top: '-6px',
                                    right: '2px',
                                    width: '2px',
                                    height: '10px',
                                    transform: 'rotate(300deg)',
                                    backgroundColor: '#ccc',
                                    borderBottomLeftRadius: '4px',
                                  }}
                                />
                                <div
                                  style={{
                                    position: 'absolute',
                                    display: 'none',
                                    top: '-2px',
                                    right: '2px',
                                    width: '2px',
                                    height: '10px',
                                    transform: 'rotate(60deg)',
                                    backgroundColor: '#ccc',
                                    borderTopLeftRadius: '4px',
                                  }}
                                />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td style={{ width: '22%', textAlign: 'end' }}>
                      <table>
                        <tbody>
                          <tr>
                            <td style={{ fontWeight: '500' }}>
                              {formatDate(
                                getNewDate(flightleg.arrdate),
                                DATE_MONTH_YEAR_VIEW_FORMAT,
                              )}
                              , {formatTimeString(flightleg.arrtime)}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ fontSize: '12px' }}>
                              {flightleg.destination_name}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ fontSize: '10px' }}>
                              {getTerminalNumberwithTerminal(
                                flightleg.arrterminal,
                              ) !== '' &&
                                `${getTerminalNumberwithTerminal(
                                  flightleg.arrterminal,
                                )}`}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td style={{ width: '20%', textAlign: 'end' }}>
                      <table width="100%">
                        <tbody>
                          <tr>
                            <td style={{ fontSize: '16px', fontWeight: '600' }}>
                              {legIndex === 0 &&
                                secIndex === 0 &&
                                showHideFare && (
                                  <>
                                    {showInput ? (
                                      <span>
                                        {appConfig?.appCurrency} {fare.totalfq}
                                      </span>
                                    ) : (
                                      <span>
                                        {appConfig?.appCurrency}{' '}
                                        {getAmount(fare.totalfq)}
                                      </span>
                                    )}
                                  </>
                                )}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ color: '#5b5b5b', fontSize: '10px' }}>
                              Baggage Allowance:{' '}
                              {getCabinBaggage(
                                flightleg.bagweight,
                                flightleg.bagunit,
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  {flightleg.destination !== finalDestination && (
                    <tr>
                      <td
                        colSpan="5"
                        style={{
                          marginBlock: '8px',
                          textAlign: 'center',
                          fontSize: '10px',
                        }}
                      >
                        <span
                          style={{
                            width: '300px',
                            marginLeft: '175px',
                            marginBlock: '4px',
                            display: 'block',
                            border: '1px solid #ccc',
                            backgroundColor: '#ccc',
                            padding: '2px 12px',
                            color: '#1e1e1e',
                          }}
                        >
                          {getConnectingTime(
                            flightleg.arrtime,
                            flightleg.arrdate,
                            onwardFlight.flightlegs[legIndex + 1].deptime,
                            onwardFlight.flightlegs[legIndex + 1].depdate,
                          )}{' '}
                          layover in {flightleg.destination_name}
                        </span>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </React.Fragment>
  ));
}

IntlMuliCityEmailCard.propTypes = {
  flight: PropTypes.object.isRequired,
  fare: PropTypes.object.isRequired,
  isLast: PropTypes.bool.isRequired,
  showHideFare: PropTypes.bool.isRequired,
  showInput: PropTypes.bool.isRequired,
  onFareUpdate: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  markUpToBeAdded: PropTypes.any.isRequired,
  searchRequest: PropTypes.any.isRequired,
};

export default IntlMuliCityEmailCard;
